import { Component, Host, Prop, h } from '@stencil/core';
import { CustomerInfo } from '../customer-overview-component/customer-overview-component';
import { ProductData } from '../order-overview-component/order-overview-component';

@Component({
  tag: 'overview-component',
  styleUrl: 'overview-component.scss',
  shadow: true,
})
export class OverviewComponent {
  @Prop() productData: ProductData[] = [];
  @Prop() customerInfo: CustomerInfo | undefined;

  render() {
    return (
      <Host>
        <h3>Übersicht</h3>
        <customer-overview-component customerInfo={this.customerInfo} />
        <order-overview-component productData={this.productData} />
        <div class="subtitle">Die Preise enthalten alle amtlichen Gebühren.</div>
      </Host>
    );
  }
}
